import AbstractNormalizersResolver from "../../core/AbstractNormalizersResolver";
import FilterNormalizer from "./FilterNormalizer";
export default class FilterNormalizersResolver extends AbstractNormalizersResolver {
    register() {
        return [
            new FilterNormalizer(),
        ];
    }
}
